import * as actionType from '../types/auth';

export function auth(payload, history) {
  return {
    type: actionType.AUTH_REQUEST,
    payload,
    history
  };
}

export function authSuccess(payload) {
  return {
    type: actionType.AUTH_SUCCESS,
    payload
  };
}

export function authFail(payload) {
  return {
    type: actionType.AUTH_FAIL,
    payload
  };
}

export function getUrlWebSSOLogin(payload) {
  return {
    type: actionType.GET_URL_WEBSSO_LOGIN,
    payload
  };
}
export function getUrlWebSSOLoginSuccess(payload) {
  return {
    type: actionType.GET_URL_WEBSSO_LOGIN_SUCCESS,
    payload
  };
}
export function getUrlWebSSOLoginFail(payload) {
  return {
    type: actionType.GET_URL_WEBSSO_LOGIN_FAIL,
    payload
  };
}

export function getUrlWebSSOLogout(payload) {
  return {
    type: actionType.GET_URL_WEBSSO_LOGOUT,
    payload
  };
}
export function getUrlWebSSOLogoutSuccess(payload) {
  return {
    type: actionType.GET_URL_WEBSSO_LOGOUT_SUCCESS,
    payload
  };
}
export function getUrlWebSSOLogoutFail(payload) {
  return {
    type: actionType.GET_URL_WEBSSO_LOGOUT_FAIL,
    payload
  };
}
